export function toggleStickyLink($stickyLink, isVisible) {
  if (isVisible) {
    $stickyLink.classList.remove('sticky-link--hidden');
  } else {
    $stickyLink.classList.add('sticky-link--hidden');
  }
}

export function updateStickyLinkNumber($stickyLink, number) {
  const $number = $stickyLink.querySelector('.sticky-link__number');
  if ($number) {
    const $inner = $number.querySelectorAll('.sticky-link__number-inner');
    if ($inner) {
      $inner.forEach(($e) => {
        const s = $e;
        s.textContent = number;
      });
    }
  }
}

document.querySelectorAll('.sticky-link').forEach(($stickyLink) => {
  if (document.querySelector('.page__content')) {
    $stickyLink.addEventListener('click', (e) => e.currentTarget.blur());
  }
});
